import React, { useLayoutEffect, useRef, useState } from 'react'

const ImageWithFallback = ({ src, alt, name, size = 25 }) => {
    const [status, setStatus] = useState('loading');
    const imgRef = useRef(null);
    const firstLetter = name?.[0]?.toUpperCase() || '?';
    const id = btoa(name).slice(0, 6);

    // ✅ useLayoutEffect ensures DOM updates are batched *before* paint
    useLayoutEffect(() => {
        if (!src) {
            setStatus('error');
            return;
        }

        const img = new Image();
        img.src = src;

        if (img.complete && img.naturalWidth !== 0) {
            setStatus('loaded');
        } else {
            setStatus('loading');
        }
    }, [src]);

    const handleLoad = () => setStatus('loaded');
    const handleError = () => setStatus('error');

    return (
        <div style={{ width: size, height: size, position: 'relative' }}>
            {status === 'loading' && (
                <div
                    className="animate-pulse bg-gray-300 rounded-full"
                    style={{
                        width: size,
                        height: size,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 1,
                    }}
                />
            )}

            {status === 'error' && (
                <div
                    id={id}
                    style={{
                        width: size,
                        height: size,
                        fontSize: size / 2,
                        backgroundColor: '#566fff',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 1,
                    }}
                >
                    {firstLetter}
                </div>
            )}

            <img
                ref={imgRef}
                src={src}
                alt={alt || name}
                onLoad={handleLoad}
                onError={handleError}
                style={{
                    width: size,
                    height: size,
                    borderRadius: '50%',
                    objectFit: 'cover',
                    display: status === 'loaded' ? 'block' : 'none',
                }}
                className="object-cover rounded-full"
            />
        </div>
    );
};

export default ImageWithFallback